export const KEYBR_STATIC =
  process.env.KEYBR_STATIC === "1" || process.env.KEYBR_STATIC === "true";
